import { Component } from '@theme/component';

class FormwinkOfferClock extends Component {
  #timer;
  #end;
  #serverNow;
  #started;
  connectedCallback() {
    super.connectedCallback();
    this.#end = Date.parse(this.dataset.end);
    this.#serverNow = Number(this.dataset.now) * 1000;
    this.#started = performance.now();
    clearInterval(this.#timer);
    this.#tick();
    if (!this.hidden) this.#timer = setInterval(this.#tick, 1000);
  }
  disconnectedCallback() {
    clearInterval(this.#timer);
    super.disconnectedCallback();
  }
  #tick = () => {
    const now = this.#serverNow + performance.now() - this.#started;
    const remaining = Math.ceil((this.#end - now) / 1000);
    if (!Number.isFinite(remaining) || remaining <= 0) {
      this.hidden = true;
      clearInterval(this.#timer);
      return;
    }
    const output = this.querySelector('[data-offer-countdown]');
    if (!output) return;
    const days = Math.floor(remaining / 86400);
    const hours = Math.floor(remaining % 86400 / 3600);
    const minutes = Math.floor(remaining % 3600 / 60);
    const seconds = remaining % 60;
    output.textContent = this.dataset.countdown
      .replace('{days}', String(days))
      .replace('{hours}', String(hours).padStart(2, '0'))
      .replace('{minutes}', String(minutes).padStart(2, '0'))
      .replace('{seconds}', String(seconds).padStart(2, '0'));
    output.hidden = false;
  };
}
if (!customElements.get('fw-offer-clock')) customElements.define('fw-offer-clock', FormwinkOfferClock);
